import { TagModel, TagType } from '@/models/tag';
import { Tag } from '@/api/types/tag';

function transformTagType(type: string) : TagType {
  switch (type) {
    case 'classification': {
      return TagType.CLASSIFICATION;
    }

    case 'experience': {
      return TagType.EXPERIENCE;
    }

    default: {
      return TagType.UNKNOWN;
    }
  }
}

export function transformTag(tag: Tag) : TagModel {
  const type = transformTagType(tag.type);
  const label = tag.label ?? tag.value;

  return {
    type,
    label,
    id: tag.id
  };
}

export function transformTags(tags: Tag[]) : TagModel[] {
  return tags.map(transformTag);
}
